export default "__VITE_ASSET__DzfHemWY__"